import { DrawingTool, DrawingToolType, ShapeConfig } from "./drawing-tool";

export class HandDrawingTool extends DrawingTool {
    protected TOOL_TYPE: DrawingToolType;
    public onTouchMove(currentShape: any, currentX: any, currentY: any, startX: any, startY: any): void {
        
    }
    public onTouchEnd(currentShape: any, currentX: any, currentY: any, startX: any, startY: any): void {
        
    }
    public resetTool() {
        
    }
    protected addNewShape(shapeX: any, shapeY: any, id: any, color?: string | undefined, parameters?: any): ShapeConfig {
        throw new Error("Method not implemented.")
    }

}